export default {
  priv: 'manage',
  overviewTitle: 'ConfigParams',
  detailTitle: 'ConfigParam',
  deleteTitle: 'dit ConfigParam',
  url: '/manage/configparams',
  apiUrl: '/configparams/',
  sortBy: ['name_nl'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'manage/configparams',
  quickFilter: {
    text: 'Zoek op name',
    value: 'name_nl',
    type: 'text'
  },
  newRecord: {
  },
  // isReadOnlyOverview: true,
  // customEditable(context, item) {
  //   return false;
  // },
  // customDeletable(context, item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Name', value: 'name', link: '/manage/configparams/{id}', width: '10%'},
    {text: 'Name_Nl', value: 'name_nl', width: '10%'},
    {text: 'Type', value: 'type', width: '10%'},
    {text: 'Value', value: 'value', width: '10%'}
  ]
};
